module.exports = __webpack_public_path__ + "static/img/share.6ed097e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/share.png
// module id = wzMg
// module chunks = 1 3